module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTAiIGhlaWdodD0iNTIiIHZpZXdCb3g9IjAgMCA5MCA1MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggb3BhY2l0eT0iMC45IiBkPSJNNjQuNDY5MyA1MkwwIDUyTDAgMEw5MCAwTDY0LjQ2OTMgNTJaIiBmaWxsPSIjQUYwMDBGIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjAuMDAwMSAzNUg0OC4wMDAxVjMySDIwLjAwMDFWMzVaTTIwLjAwMDEgMjdINTcuMDAwMVYyNEgyMC4wMDAxVjI3Wk0yMCAxNlYxOUg2NFYxNkgyMFoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-menu-open.svg
// module id = A8yv
// module chunks = 1